import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { delay } from 'rxjs/operators';
import { MessagesButtonComponent } from '../../../messages/messages-button/messages-button.component';
import { SettingsService } from '../../../shared/settings/settings.service';
import { LogoComponent } from '../../components/logo/logo.component';
import { HttpLoadingService } from '../../http-loading.service';
import { MenuService } from '../../menu.service';

@Component({
  selector: 'lfw-navigation-toolbar',
  templateUrl: './navigation-toolbar.component.html',
  styleUrls: ['./navigation-toolbar.component.css'],
  imports: [
    MatToolbar,
    MatIconButton,
    MatIcon,
    LogoComponent,
    MessagesButtonComponent,
    MatProgressBar,
    RouterLink,
    RouterLinkActive,
    MatTooltip,
    AsyncPipe,
    TranslatePipe
  ]
})
export class NavigationToolbarComponent {
  protected readonly menuService = inject(MenuService);
  private readonly settingsService = inject(SettingsService);
  protected readonly loading$ = inject(HttpLoadingService).loading$.pipe(delay(1));

  protected get isMenuVisible(): boolean {
    return (
      !this.settingsService.settings.viewMode.isFullScreen &&
      !this.settingsService.RunningInWindowMode() &&
      this.menuService.navigationAllowed
    );
  }

  protected get searchButtonVisible(): boolean {
    return false;
  }

  protected showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
